import { TimeEntriesTab } from "@/components/blocks/time/time-entries-tab";

import { useProjectDetailsContext } from "../context";

export function TimeTab() {
  const ctx = useProjectDetailsContext();
  // Destructure all needed values from context
  const {
    project, employees,
    numericProjectId,
    timeEntries,
    timeTabPrefilterNames,
    timeTabPrefilterBillable,
    // Additional items that may be used
  } = ctx;

  return (
    <>
                <TimeEntriesTab
                  projectId={numericProjectId}
                  projectCode={project?.code}
                  timeEntries={timeEntries}
                  employees={employees}
                  initialEmployeeNames={timeTabPrefilterNames}
                  initialBillableOnly={timeTabPrefilterBillable}
                />

    </>
  );
}
